import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  TemplateVersion,
  TemplateVersionSummary,
  TemplateVersionDecision,
  CreateTemplateVersionRequest,
  RestoreTemplateVersionRequest,
  AddTemplateVersionDecisionRequest,
} from '../models/template-version/template-version.interface';

@Injectable({
  providedIn: 'root',
})
export class TemplateVersionService {
  private getHostUrl = () => environment.scheme + environment.host + environment.port + '/';
  private readonly baseUrl = `${this.getHostUrl()}api/v${environment.version}/TemplateVersion`;

  constructor(private http: HttpClient) {}

  getVersions(templateId: string, language: string, offset = 0, limit = 100): Observable<TemplateVersionSummary[]> {
    const params = new HttpParams()
      .set('templateId', templateId)
      .set('language', language)
      .set('offset', String(offset))
      .set('limit', String(limit));
    return this.http.get<TemplateVersionSummary[]>(`${this.baseUrl}/getVersions`, { params });
  }

  getVersion(templateId: string, language: string, version: number): Observable<TemplateVersion> {
    const params = new HttpParams()
      .set('templateId', templateId)
      .set('language', language)
      .set('version', String(version));
    return this.http.get<TemplateVersion>(`${this.baseUrl}/getVersion`, { params });
  }

  createVersion(request: CreateTemplateVersionRequest): Observable<TemplateVersion> {
    return this.http.post<TemplateVersion>(`${this.baseUrl}/createVersion`, request);
  }

  restoreVersion(request: RestoreTemplateVersionRequest): Observable<TemplateVersion> {
    return this.http.post<TemplateVersion>(`${this.baseUrl}/restoreVersion`, request);
  }

  addDecision(request: AddTemplateVersionDecisionRequest): Observable<TemplateVersionDecision> {
    return this.http.post<TemplateVersionDecision>(`${this.baseUrl}/addDecision`, request);
  }
}
